import * as React from 'react';
import { IFilterGroup } from './shared-types';

export interface IBodyPartFilterProps { 
    categoryTheme: string,   
    filterGroup: IFilterGroup,
    currentSelection: number,
    availableBodyParts: Array<number>,
    onChangeHandler(bodyPart: number): void
}

export class BodyPartFilter extends React.Component<IBodyPartFilterProps, {}>{

    private getClassName(bodyPart: number): string {
        let className = 'filters-category-full-item ' + this.props.categoryTheme;
        if (bodyPart === this.props.currentSelection)
            className = className.concat(' active');
        if (this.props.availableBodyParts.indexOf(bodyPart) === -1)
            className = className.concat(' disabled')
        return className;
    }

    render() {
        return (
            <div className="filters-category-full filters-bodypart">
                <h6 className="filters-category-full-heading">{this.props.filterGroup.header}</h6>
                <div className="filters-category-full-container">
                    {this.props.filterGroup.filters.map((x) =>
                        <span key={x.value} className={this.getClassName(x.value)} onClick={() => this.props.onChangeHandler(x.value)}>
                            {x.text}
                        </span>
                    )}
                </div>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./~/source-map-loader!./app/src/shared/bodypart-filter.tsx